import * as Prismic from '@prismicio/client';
import { createClient } from 'src/prismicio';

export async function fetchAllBlogProfiles(
  client: Prismic.Client = createClient(),
) {
  return client.getAllByType('blog_profile');
}

export async function fetchBlogProfileByUid(
  uid: string,
  client: Prismic.Client = createClient(),
) {
  return client.getByUID('blog_profile', uid);
}

export async function fetchDocumentById(
  id: string,
  client: Prismic.Client = createClient(),
) {
  return client.getByID(id);
}

export async function fetchBlogCategories(
  client: Prismic.Client = createClient(),
) {
  return client.getByUID('blog_categories', 'blog_categories');
}

export async function fetchAllBelongStandards(
  client: Prismic.Client = createClient(),
) {
  return client.getAllByType('belong_standards');
}

export function fetchBlogPostsList({
  tags,
  authors,
  categories,
  excludedUIDs,
  page = 1,
  client = createClient(),
  pageProps = { pageSize: 9 },
}: {
  tags?: string[];
  authors?: string[];
  categories?: string[];
  excludedUIDs?: string[];
  page?: number;
  client: Prismic.Client;
  pageProps?: { pageSize: number };
}) {
  const predicates = [];
  if (categories) {
    predicates.push(
      Prismic.predicate.any('my.blog_page.categories.category', categories),
    );
  }
  if (tags) {
    predicates.push(Prismic.predicate.any('document.tags', tags));
  }
  if (excludedUIDs?.length) {
    excludedUIDs.forEach((excludedUID) =>
      predicates.push(Prismic.predicate.not('my.blog_page.uid', excludedUID)),
    );
  }
  if (authors) {
    predicates.push(Prismic.predicate.any('my.blog_page.author', authors));
  }

  return client.getByType('blog_page', {
    pageSize: pageProps.pageSize,
    page,
    orderings: {
      field: 'my.blog_page.sort_by_date',
      direction: 'desc',
    },
    predicates,
  });
}

export async function fetchNextBlogPost(
  postId: string,
  client: Prismic.Client = createClient(),
) {
  return client.getByType('blog_page', {
    pageSize: 1,
    after: postId,
    orderings: {
      field: 'my.blog_page.sort_by_date',
    },
  });
}
export async function fetchPreviousBlogPost(
  postId: string,
  client: Prismic.Client = createClient(),
) {
  return client.getByType('blog_page', {
    pageSize: 1,
    after: postId,
    orderings: {
      field: 'my.blog_page.sort_by_date',
      direction: 'desc',
    },
  });
}

export async function fetchBlogPostByUid(
  uid: string,
  client: Prismic.Client = createClient(),
) {
  return client.getByUID('blog_page', uid, {
    fetchLinks: [
      'buttonaction.title',
      'buttonaction.subtitle',
      'buttonaction.body',
    ],
  });
}

export type TextContentItem = {
  type: string;
  text: string;

  spans: { start: number; end: number; type: string; data?: any }[];
};

export type TermsOfUseResponse = {
  updated: string;
  content: TextContentItem[];
};

export async function fetchTermsOfUse(client: Prismic.Client = createClient()) {
  return client.getByUID('termsofuse', 'terms-of-use');
}

export async function fetchPrivacyPolicy(
  client: Prismic.Client = createClient(),
) {
  return client.getByUID('termsofuse', 'privacy-policy');
}

export async function fetchFlexPaymentsTermsAndConditions(
  client: Prismic.Client = createClient(),
) {
  return client.getByUID('termsofuse', 'flex-payments-terms-and-conditions');
}

export async function fetchAllLandingPages(
  client: Prismic.Client = createClient(),
) {
  return client.getAllByType('landing_page');
}

export async function fetchLandingPageByUid(
  uid: string,
  client: Prismic.Client = createClient(),
) {
  return client.getByUID('landing_page', uid, {
    fetchLinks: [
      'buttonaction.title',
      'buttonaction.subtitle',
      'buttonaction.body',
    ],
  });
}
